/**
 * 目前支持的地址类型
 */
export enum AddressType {
  EVM = 'evm',
  APP = 'app',
}
